import { customFetch } from './customFetch';
import { env } from '../env';
import { Configuration } from './configuration';

export const configuration: Configuration = {
    basePath: env.endpoint
};

export abstract class BaseApi {
    protected customFetch = customFetch;
}
